import Select from "react-select";
import PropTypes from "prop-types";
import "./styles.scss";

const SelectDropdown = ({
  className,
  isSearchable,
  value,
  onChange,
  options,
  styles,
  placeholder,
  ...restProps
}) => {
  return (
    <div data-testid="select-dropdown">
      <Select
        className={className}
        value={value}
        styles={styles}
        isSearchable={isSearchable === undefined ? true : isSearchable}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
      />
    </div>
  );
};

SelectDropdown.propTypes = {
  className: PropTypes.string,
  isSearchable: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  onChange: PropTypes.func,
  options: PropTypes.array,
  styles: PropTypes.object,
  placeholder: PropTypes.string,
};

export default SelectDropdown;
